/**************************************************
 * Nombre:       Home_Marcas
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";
import ic_uno from '../../../Recursos/ic_uno.png'
import ic_dos from '../../../Recursos/ic_dos.png'
import ic_tres from '../../../Recursos/ic_tres.png'
import ic_cuatro from '../../../Recursos/ic_cuatro.png'
import ic_cinco from '../../../Recursos/ic_cinco.png'

const Home_Marcas = () => {
    const {sCell} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        justifyContent={'center'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                    >


                        <Grid container size={{xs: 12, sm: 12, md: 11}}
                              sx={{justifyContent: 'flex-start', mb: -1.6, zIndex: 2}}>
                            <Typography
                                sx={{backgroundColor: '#fff', px: 1, fontWeight: 600, fontSize: 18}}
                            >Marcas Aliadas</Typography>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', zIndex: 1}}>
                            <Grid
                                container
                                justifyContent={'space-between'}
                                alignItems={'flex-start'}
                                size={{xs: 12, sm: 12, md: 12}}
                                sx={{border: 1, borderColor: '#00000020', p: 4, px: 6, borderStyle: 'dashed'}}
                                spacing={sCell ? 3 : 0}
                            >

                                {marcas.map((item, index) => (
                                    <img src={item.img} width={sCell ? 72 : 100} height={'auto'}
                                         style={{borderRadius: 10, opacity: 1}}
                                    />
                                ))}

                            </Grid>
                        </Grid>

                    </Grid>
                </Grid>

            </Grid>

        </Grid>
    )

}
export default Home_Marcas

const marcas = [
    {
        img: ic_uno,
    },
    {
        img: ic_dos,
    },
    {
        img: ic_tres,
    },
    {
        img: ic_cuatro,
    },
    {
        img: ic_cinco,
    },
]